import axios from 'axios';
import type {
  IGetActivationFeePrerequisitesByBoardIdParams,
  IGetActivationFeePrerequisitesByBoardIdRequest,
  IGetActivationFeePrerequisitesByBoardIdResponse,
} from '@/app-package';

const getActivationFeePrerequisitesByBoardId = async (
  params: IGetActivationFeePrerequisitesByBoardIdParams,
) => {
  const config: IGetActivationFeePrerequisitesByBoardIdRequest = {
    url: `/supra/activation_fee_prerequisites_board_id/${params.boardId}`,
    method: 'get',
  };
  try {
    const { data } =
      await axios.request<IGetActivationFeePrerequisitesByBoardIdResponse>(
        config,
      );
    return data;
  } catch (error: any) {
    // Check for 404 error and return an empty array
    if (error.response && error.response.status === 404) {
      return { canWaiveActivationFee: false };
    }
    throw error;
  }
};

export default getActivationFeePrerequisitesByBoardId;
